/*
 * $Id:: ServicesList.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import ClickableCard from '../../../../components/ClickableCard/ClickableCard';

const useStyles = makeStyles(() => ({
    servicesList: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        '@media (max-width:595px)': {
            justifyContent: 'center',
        },
    },
}));

const ServicesList = ({ readOnly, items, navigateTo }) => {
    const classes = useStyles();

    const serviceList =
        items && !!items.length && items.map((item, index) => <ClickableCard readOnly={readOnly} key={index} item={item} navigateTo={navigateTo} />);

    return <div className={classes.servicesList}>{serviceList}</div>;
};

export default ServicesList;
